export default __webpack_public_path__ + "7a0ba444441534516c02f0d623e30173.svg";